import { API_URL_MEDIA } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditMedia from "types/Media/createEditMedia";

const createMedia = (newMedia: TCreateEditMedia) =>
  apiInstance({
    url: API_URL_MEDIA,
    method: "post",
    data: newMedia,
  });

export default createMedia;
